module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/Table-45296517d519ce76202a336122fe21cf.png";